import RewardQRScreen from "./RewardQRScreen";

export default RewardQRScreen;